import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";

// Redux actions
import { getWriteMyEssayPage } from "../../../redux/slices/ServicePagesSlice";

// Components
import PageBanner from "../../components/layout/pages/PageBanner";
import AssignmentWriters from "../../components/layout/pages/AssignmentWriters";
import Help from "../../components/layout/pages/Help";
import HelpFeatures from "../../components/layout/pages/HelpFeatures";
import FAQ2 from "../../components/layout/pages/FAQ2";

const WriteMyEssay = () => {
  const dispatch = useAppDispatch();

  // Redux stores
  const { essayPageStatus, essayPageData } = useAppSelector(
    (state) => state.servicePages
  );

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    if (essayPageStatus !== "success") {
      dispatch(getWriteMyEssayPage());
    }
  }, []);

  return (
    <>
      {/* page banner area start */}
      <PageBanner
        className="about-inner-banner"
        title={essayPageData.sec_1_i_banner[0].heading}
        description={essayPageData.sec_1_i_banner[0].subheading}
        reviewSites={essayPageData.sec_1_i_banner[0].inner_banner_review}
      />
      {/* page banner area end */}

      {/* wrapper area start */}
      <div className="wrapper">
        {/* Assignment Writers */}
        <section className="assignment-writers-area">
          <div className="container">
            <AssignmentWriters
              title1={essayPageData.sec_main.sec_2_h1}
              title2={essayPageData.sec_main.sec_2_h2}
              data={essayPageData.sec_main.sec_2_assignment_writer}
            />
          </div>
        </section>

        {/* Get Help */}
        <Help
          headingOneText={essayPageData.sec_main.sec_3_h1}
          headingTwoText={essayPageData.sec_main.sec_3_h2}
          data={essayPageData.sec_main.sec_3_it_1}
        />

        {/* help features */}
        <HelpFeatures
          headingOneText={essayPageData.sec_main.sec_4_h1}
          headingTwoText={essayPageData.sec_main.sec_4_h2}
          data={essayPageData.sec_main.sec_4_it_1}
        />

        {/* faq area 2 */}
        <FAQ2 dataType="write_my_paper" data={essayPageData.sec_main.sec_5_at} />
      </div>
      {/* wrapper area end */}
    </>
  );
};

export default WriteMyEssay;
